import React from "react";
import { HiOutlineMusicNote } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneMusic } from "../../../lib/sysNavigation/SysNavigation";

type MusicRow = {
  music_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<MusicRow>
    type={_TYPES_.MUSIC}
    title="Music"
    subtitle="Music content promoted on the public site."
    icon={<HiOutlineMusicNote className="h-5 w-5" />}
    addRoute="/data/music/add"
    editRoute="/data/music/edit"
    pushOne={pushOneMusic}
    dataKey="music"
    countKey="musicCount"
    idField="music_id"
    titleField="title"
  />
);

export default Overview;
